import React from 'react';
// This component handles focus-forwarding when navigating through the calendar grid.
// When the customer focuses that component the `next` callback function is called
// with forwards the focus.
var TabTrap = function (_a) {
    var focusNextCallback = _a.focusNextCallback;
    return React.createElement("div", { tabIndex: 0, onFocus: focusNextCallback });
};
export default TabTrap;
